import React from 'react'
import gambar from './assets/img.jpeg'

function AboutDev() {
    return (
        <div>
            <h1 class="tulisan"> About Developer</h1>
            <div class="mainn centerr">
                <div class="cardddd">
                    <img src={gambar} alt=""></img>
                    <h1>Karmite</h1>
                    <h4>Frontend.And.Backend.Developer</h4>
                    <div class="icon">
                        <i class="fab fa-js fa-2x"></i>
                        <i class="fab fa-react fa-2x"></i>
                        <i class="fab fa-html5 fa-2x"></i>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutDev